import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import AboutUsPage from "images/demo/AboutUsPage.jpeg"
import {useSelector} from "react-redux";
import {LangProvider} from "../lang";
import translate from "../lang/translate";



const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
    const locale = useSelector(state => state.locale);
    return (
        <LangProvider locale={locale}>
            <AnimationRevealPage>
                <Header />
                <MainFeature1
                    subheading={<Subheading></Subheading>}
                    heading={translate('about_us.about_us')}
                    buttonRounded={false}
                    description={translate('about_us.description1')}
                    imageSrc="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
                />
                <MainFeature1
                    subheading={<Subheading></Subheading>}
                    heading={translate('about_us.who_are_we')}
                    buttonRounded={false}
                    description={translate('about_us.description2')}
                    imageSrc="https://images.unsplash.com/3/doctype-hi-res.jpg?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80"
                    textOnLeft={false}
                />

                <Footer />
            </AnimationRevealPage>
        </LangProvider>
    );
};
